export const GET_FINANCIAL_DATA = 'getFinancialData';
export const GET_ANALYSIS_EXPLANATIONL_DATA = 'getAnalysisExplanationData';

export const GET_MEETINGS_DATA = 'getMeetingsData';
export const GET_NOTIFICATION_DATA = 'getNotificationData';
export const GET_ONE_REPORTS_DATA = 'getOneReportsData';
export const GET_ANNUAL_REPORTS_DATA = 'getAnnualReportsData';
export const GET_SUSTAINABILITY_REPORTS_DATA = 'getSustainabilityReportsData';
export const GET_FORM_56_REPORTS_DATA = 'getform56ReportsData';

export const GET_SET_STOCK_QUOTATION_DATA = 'getStockQuotationData';
export const GET_SET_STOCK_NEWS_DATA = 'getStockNewsData';

export const GET_FNEWS_CLIPPINGS_DATA = 'getNewsClippingsData';
export const GET_AD_ELECTRONIC_DATA = 'getAdElectronicData';

export const GET_CONTACT_INVESTOR = 'getContactInvestor';
export const GET_RECEIVE_EMAIL_INVESTOR = 'getReceiveEemailsInvestor';
export const GET_CANCEL_EMAIL_INVESTOR = 'getCancelEemailsInvestor';

export const GET_CALENDAR_INVESTOR = 'getCalendarInvestor';

export const GET_ACTIVITY_DATA = 'getActivityData';

export const GET_SECURITIES_ANALYSIS_DATA = 'getSecuritiesAnalysisData';

export const GET_NEWS_MEDIAS = 'getNewsMediasData';

export const GET_CREDIT_RATINGS_DATA = 'getCreditRatingsData';



























